import React from "react";
import { NavLink } from "react-router-dom";
import { safeFormat, formatLabel, formatMarketPrice } from "../../../../utils/financialHelper";
import "./Banner.less";

interface BannerProps {
  reitData: {
    id: string;
    image: string;
    name: string;
    locations: string;
    assetClass: string;
    listingDate: string;
    bse: { label: string; value: number; change: number };
    nse: { label: string; value: number; change: number };
    buttons: string[];
  };
}

const compareArrow = new URL(
  "../../../../assets/compare-arrow.png",
  import.meta.url
).href;

const Banner: React.FC<BannerProps> = ({ reitData }) => {
  return (
    <section className="banner">
      <div className="banner__overlay"></div>

      <div className="banner__content">
        {/* Left Image */}
        <div className="banner__left">
          <img src={reitData.image} alt={reitData.name} />
        </div>

        {/* Right Content */}
        <div className="banner__right">
          {/* Top Section */}
          <div className="banner__top">
            <div className="banner__top-left">
              <h2>{reitData.name}</h2>
              <p>{reitData.locations}</p>
            </div>
            <div className="banner__top-right">
              <p style={{ margin: "6px 0" }}>
                Primary Asset Class:
                <strong> {formatLabel(reitData.assetClass)}</strong>
              </p>

              <p>
                Listing Date:<strong> {reitData.listingDate}</strong>
              </p>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="banner__bottom">
            <div className="banner__bottom-left">
              <div className="reit-stats-row">
                <div className="stat-block">
                  <span>
                    BSE <span className="tag">Prev Close</span>
                  </span>
                  <p>
                    {formatMarketPrice(reitData.bse.value)}{" "}
                    <span
                      className="change"
                      style={{
                        color: reitData.bse.change >= 0 ? "green" : "red",
                      }}
                    >
                      (
                      {reitData.bse.change >= 0
                        ? `+${formatMarketPrice(reitData.bse.change)}`
                        : `-${formatMarketPrice(Math.abs(reitData.bse.change))}`}
                      )
                    </span>
                  </p>
                </div>

                <div className="stat-block">
                  <span>
                    NSE <span className="tag">Prev Close</span>
                  </span>
                  <p>
                    {formatMarketPrice(reitData.nse.value)}{" "}
                    <span
                      className="change"
                      style={{
                        color: reitData.nse.change >= 0 ? "green" : "red",
                      }}
                    >
                      (
                      {reitData.nse.change >= 0
                        ? `+${formatMarketPrice(reitData.nse.change)}`
                        : `-${formatMarketPrice(Math.abs(reitData.nse.change))}`}
                      )
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="banner__bottom-right">
              <NavLink
                to={`/reits/compare-properties`}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                <button className="compare">
                  <span className="compare-text">Compare</span>
                  <span className="compare-icon">
                    <img src={compareArrow} alt="compareArrow" />
                  </span>
                </button>
              </NavLink>
              <NavLink
                to={`/reits/${reitData.id}/valuation`}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                <button className="valuation">Valuation</button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
